import React from 'react';
import Chat from './components/Chat';
import { getAppContainerStyle } from './components/styles/ChatStyles';
import { WidgetConfig } from './components/types/ChatTypes';

interface AppProps {
  config: WidgetConfig;
}

function App({ config }: AppProps) {
  return (
    <div className='chat-container' style={getAppContainerStyle()}>
      <Chat config={config} />
    </div>
  );
}

export default App;
